export default "__VITE_ASSET__CBER6nmb__"